import { NOTIFY,
          } from "./actionType";


         export const notify = (payload) => ({ type:NOTIFY,payload})

   